import {get, post, put, _delete} from './Tools';

const getById = async (conceptId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}credito_infonavit/${conceptId}`);
  return response;
};
const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}credito_infonavit`);
  return response;
};
const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}credito_infonavit`, payload);
  return response;
};
const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}credito_infonavit`, payload);
  return response;
};
const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}credito_infonavit/${id}`);
  return response;
};


const getAmortizacionesByCredito = async (creditoId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}amortizacion_infonavit/credito/${creditoId}`);
  return response;
};

const createAmortizacion = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}amortizacion_infonavit`, payload);
  return response;
};

const updateAmortizacion = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}amortizacion_infonavit`, payload);
  return response;
};

const deleteAmortizacion = async (amortizacionId) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}amortizacion_infonavit/${amortizacionId}`);
  return response;
};

export { getAll, getById, insert, update, drop, getAmortizacionesByCredito, createAmortizacion, updateAmortizacion, deleteAmortizacion};
